var _path, _path2, _g, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMentalHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 90,
    viewBox: "0 0 108 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8374_34207",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: -2,
    width: 91,
    height: 95
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.6137 -0.75744C66.0466 1.29022 72.1335 8.18535 76.3316 15.3588C81.0403 23.407 81.978 32.585 86.9737 40.5371C92.3598 49.1088 100.786 56.4645 102.111 66.4808C103.429 76.4475 96.5245 86.4538 87.1506 90.2642C70.8687 96.8843 58.4513 85.3604 43.5711 81.5766C39.8068 80.619 35.869 80.3572 32.1781 79.1412C15.9563 73.7968 9.32882 52.5547 13.4802 37.565C14.6849 33.2146 16.5804 29.0165 18.7829 25.014C24.0923 15.3621 30.613 6.10787 40.1105 1.59837C44.4354 -0.455923 48.5233 -1.38367 52.3243 -1.38367C54.1564 -1.38367 55.9184 -1.1683 57.6103 -0.75744",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8374_34207)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8374_34207",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: -2,
    width: 91,
    height: 95
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6039 -0.75744C66.0368 1.29022 72.1237 8.18535 76.3218 15.3588C81.0305 23.407 81.9683 32.585 86.9639 40.5371C92.3501 49.1088 100.776 56.4645 102.101 66.4808C103.419 76.4475 96.5148 86.4538 87.1408 90.2642C70.859 96.8843 58.4415 85.3604 43.5613 81.5766C39.797 80.619 35.8592 80.3572 32.1683 79.1412C15.9466 73.7968 9.31906 52.5547 13.4704 37.565C14.6751 33.2146 16.5706 29.0165 18.7731 25.014C24.0825 15.3621 30.6032 6.10787 40.1007 1.59837C44.4256 -0.455923 48.5136 -1.38367 52.3146 -1.38367C54.1466 -1.38367 55.9087 -1.1683 57.6006 -0.75744",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8374_34207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.307 -7.55316H-2.05762V117.434H119.307V-7.55316Z",
    fill: "#8ED479"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.24 109.823L30.1963 100.181C30.1963 89.5717 31.5612 80.7846 47.6194 78.9457L48.5438 62.0641C47.2023 59.2576 46.2479 55.8946 45.8407 51.9782C44.6394 40.3416 47.3124 32.9064 58.5351 31.7633C68.9904 30.6997 74.1629 36.1137 77.3398 46.1466C77.8237 47.3925 80.2064 53.7276 79.6158 55.1192C79.0251 56.5075 77.0228 57.4287 75.3509 57.6507C74.8003 66.7293 71.2563 71.8617 64.9124 72.5078C64.7989 72.5177 64.6821 72.5244 64.5687 72.5343L65.0325 82.5705C78.4912 87.8222 89.2367 99.2169 89.2367 109.826",
    fill: "#103540"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7932 48.8669C61.7454 48.9397 60.6808 49.0756 59.7297 49.5229C58.1413 50.2717 57.337 52.0808 56.3759 53.4492C56.1423 53.7839 55.8887 54.0821 55.6184 54.3571C53.0688 56.9415 48.5971 55.3876 48.22 51.7926C48.22 51.7727 48.2167 51.7561 48.2133 51.7362C47.6193 45.9875 48.0798 41.8491 49.6182 39.0792C51.2368 36.1667 54.1467 34.5895 58.7787 34.119C59.5595 34.0395 60.3204 33.9998 61.0345 33.9998C64.662 33.9998 67.5119 35.0302 69.7478 37.1508C70.779 38.1315 71.7167 39.3707 72.5676 40.8849C73.3352 42.2501 73.3252 43.9266 72.4976 45.252C72.1038 45.8848 71.5966 46.468 70.9592 46.9882",
    fill: "#FFCCCC"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1905 29.3578C50.9087 29.3578 54.7335 25.5602 54.7335 20.8756C54.7335 16.191 50.9087 12.3934 46.1905 12.3934C41.4723 12.3934 37.6475 16.191 37.6475 20.8756C37.6475 25.5602 41.4723 29.3578 46.1905 29.3578Z",
    fill: "#FFEDCC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5791 38.6253H43.5211C41.7257 38.6253 40.2707 37.1807 40.2707 35.3981C40.2707 31.2464 36.8802 27.8767 32.6955 27.8767C32.6955 27.8767 3.1519 27.8966 2.81818 27.8966C-6.94958 27.8966 -14.8652 35.7593 -14.8652 45.4542C-14.8652 47.0844 -16.1968 48.4064 -17.8386 48.4064H-22.2369C-27.6731 48.4064 -32.0781 52.78 -32.0781 58.1775C-32.0781 60.8481 -29.899 63.0117 -27.2093 63.0117H6.83608L6.84609 62.9521H26.168C28.0936 62.9521 29.6553 61.4014 29.6553 59.4896C29.6553 56.3618 27.1024 53.8271 23.9522 53.8271H11.3479C10.1799 53.8271 9.23214 52.8861 9.23214 51.7264C9.23214 49.5263 11.0275 47.7437 13.2434 47.7437H53.449C55.1543 47.7437 56.5826 46.3985 56.6093 44.7054C56.6627 41.3555 53.9429 38.622 50.5824 38.622L50.5791 38.6253Z",
    fill: "#D2F1F9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentalHealth);
export default __webpack_public_path__ + "static/media/MentalHealth.0e9a8ccf9335fbec33629042cf453114.svg";
export { ForwardRef as ReactComponent };